import { APP_CONFIG } from '../../config';
import { put } from '../request';

export const localLogin = async (username: string): Promise<void> => {
  await put(`${APP_CONFIG.apiEndpoint}/login`, { username });
};
